import { Directive, Input, Renderer2, ElementRef, HostListener } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { Sort } from '@shared/utils/sort';


@Directive({
  selector: '[appSort], [appSortFormArray]'
})
export class SortDirective {

  @Input() appSort: Array<any> = new Array<any>();
  @Input() appSortFormArray: FormArray;
  @Input() key: any;

  constructor(private renderer: Renderer2, private targetElement: ElementRef) { }

  @HostListener("click")
  sortData() {

    const sort = new Sort();

    const elem = this.targetElement.nativeElement;

    const order = elem.getAttribute("data-order");

    const type = elem.getAttribute("data-type");

    const property = elem.getAttribute("data-name") ? elem.getAttribute("data-name") : this.key;

    //en caso que la tabla use FormArray
    this.getArray();

    if(property != "#"){
    
      if (order === "desc") {
        this.appSort.sort(sort.startSort(property, order, type));
        elem.setAttribute("data-order", "asc");
      } else {
       // console.log(this.appSort.reverse());
        this.appSort.sort(sort.startSort(property, order, type));
        elem.setAttribute("data-order", "desc");
      }
    
    }else{
      this.appSort = this.invertArray(this.appSort);
    }

    //en caso que la tabla use FormArray este debe actualizarce con un patchvalue para que se ejecute el método de ordenamiento
    this.updateFormArray();

  }

  getArray():void{
    if(this.appSortFormArray){
      this.appSort = this.appSortFormArray.value; 
    }
  }

  updateFormArray():void{
    if(this.appSortFormArray){
      this.appSortFormArray.patchValue(this.appSort);      
    }
  }

  /**
   * Método con el cual se invertiran las posiciones del array, en sentido ascendente o descendente; dependiendo el orden que este tenga
   * este método será valido cuando en el data-name se pase el atributo '#', haciendo referencia a que esa columna no corresponde a ninguna key del formArray
   */
  invertArray(array: Array<any>){
    return array.reverse();
  }

}